
/**************START FIREBASE **************/
import { FirebaseApp, initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { Firestore, getFirestore } from "firebase/firestore"; 

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

const firebaseConfig = {
  apiKey: "AIzaSyCe2W3tKoiRYZITKXItD3Q_Fvwb2Y_LoYI",
  authDomain: "legalscanapp.firebaseapp.com",
  projectId: "legalscanapp",
  storageBucket: "legalscanapp.firebasestorage.app",
  messagingSenderId: "968024119497",
  appId: "1:968024119497:web:8f3c2232667c0c1e9a5518",
  measurementId: "G-4MM6BSDNNR"
};

/**************END FIREBASE **************/

let app: FirebaseApp | null = null;
let db: any = null;
const firebaseApp = (): FirebaseApp => {
    if (app) return app;

    // Initialize Firebase
    app = initializeApp(firebaseConfig);

    const analytics = getAnalytics(app);

    return app;

}

const firebaseDB = (): Firestore => {
    if (db) return db;

    db = getFirestore(firebaseApp());
    return db;
}

export { firebaseApp, firebaseDB };
